import Home from './home';
// import Android from './android';
// import Ios from './ios';
// import Guide from './guide';
import getSiteConfig from '../../siteConfig.js';
var siteConfig = getSiteConfig(process.env.SITE_ID);
var mods = [];
mods = [
    {
        key: 'home',
        Component: Home
    }
];
// if (setNewsit(process.env.SITE_ID)) {
//   //iphone
//   mods =
//     siteConfig.tfAppKey && isOnIPhone
//       ? [
//           {
//             key: 'home',
//             Component: Home
//           }
//           // {
//           //   key: 'guide',
//           //   Component: Guide
//           // }
//         ]
//       : [
//           {
//             key: 'home',
//             Component: Home
//           }
//         ];
// } else {
//   //andriod
//   mods = [
//     {
//       key: 'home',
//       Component: Home
//     }
//     // {
//     //   key: 'guide',
//     //   Component: Guide
//     // }
//   ];
// }
export default mods;
